if (!customElements.get("story-popup")) {
    class StoryPopup extends HTMLElement {
        constructor() {
            super();
            this.videoWrapper = this.querySelector('.td-popup__container') || null;
            this.popup = this.querySelector('.td-popup__modal') || null;
            this.closer = this.querySelector('.td-popup__modal-closer') || null;
        }
    
        connectedCallback() {
            if (!this.popup) return
            if (this.videoWrapper) {
                this.videoWrapper.addEventListener('click', () => {
                    this.popup.style.display = 'flex';
                })
            }
            if (this.closer) {
                this.closer.addEventListener('click', () => {
                    this.popup.style.display = 'none';
                })
            }
        }
    }

    customElements.define("story-popup", StoryPopup);
}